/**
 * vue过滤器
 */
export default {
  install(Vue) {
    // 过滤为数字，并保留两位小数，可为负
    Vue.filter('decimal', val => {
      val = +val;
      return val ? val.toFixed(2) : '0.00';
    });
    // 过滤为数字，并保留n位小数，可为负
    Vue.filter('customDecimal', (val, num) => {
      val = +val;
      const defaultVal = num ? Number(0).toFixed(num) : '0.00';
      return val ? val.toFixed(num) : defaultVal;
    });
    // 转换为大写字母
    Vue.filter('upper', {
      read: val => val,
      write: val => val.toUpperCase(),
    });
    // 过滤数字、字母以外
    Vue.filter('letterAndNum', {
      read: val => val,
      write: val => val.replace(/[^a-zA-Z0-9]/g, ''),
    });
    // 过滤数字以外
    Vue.filter('number', {
      read: val => val,
      write: val => val.replace(/[^0-9]/g, ''),
    });
    // 过滤数字和逗号以外
    Vue.filter('numberAndComma', {
      read: val => val,
      write: val => val.replace(/[^0-9,]/g, ''),
    });
    // 过滤字母以外
    Vue.filter('letter', {
      read: val => val.toUpperCase(),
      write: val => val.replace(/[^a-zA-Z]/g, ''),
    });
    // 时间格式化
    Vue.filter('dateFormat', (val, format = 'yyyy-MM-dd hh:mm:ss') => {
      if (!val) {
        return '';
      }
      var date = new Date(val);
      const map = {
        M: date.getMonth() + 1, // 月份
        d: date.getDate(), // 日
        h: date.getHours(), // 小时
        m: date.getMinutes(), // 分
        s: date.getSeconds(), // 秒
        q: Math.floor((date.getMonth() + 3) / 3), // 季度
        S: date.getMilliseconds(), // 毫秒
      };
      format = format.replace(/([yMdhmsqS])+/g, (all, t) => {
        let v = map[t];
        if (v !== undefined) {
          if (all.length > 1) {
            v = `0${v}`;
            v = v.substr(v.length - 2);
          }
          return v;
        } else if (t === 'y') {
          return (`${date.getFullYear()}`).substr(4 - all.length);
        }
        return all;
      });
      return format;
    });
    // 特殊字符
    Vue.filter('specialChar', (string, format) => {
      if (!string) {
        return '';
      }
      if (format === 'ok') {
        return '√';
      }
    });
  },
};
